module.exports = __webpack_public_path__ + "img/blueArrow.990090d8.svg";